import http from '../../../common/axios/axios.instance';
import { ENDPOINT_USER_DELETE_ACCOUNT, ENDPOINT_USER_GET, ENDPOINT_USER_UPDATE } from '../endpoints/user.endpoints';

export const getUserApi = () => {
  return http.get(ENDPOINT_USER_GET).then((response) => response.data);
};

export const updateUserProfileApi = (body) => {
  return http.post(ENDPOINT_USER_UPDATE, body).then((response) => response.data);
};

export const deleteAccountApi = () => {
  return http.delete(ENDPOINT_USER_DELETE_ACCOUNT).then((response) => response.data);
};
